import { Console } from 'console';
import { Mv_PostCode, Mv_ApplyCaseProcess, Mv_DecryptRouter, Mv_ApplyCase_Search } from './../model/apply-case-model';
import { Mv_Code, Select, Mv_WaterRecordStatistics, Mv_WaterRecordPersonGroup, Mv_WaterRecordLicen, Mv_WaterRecordData, M_WaterRecordPerson, Mv_SeminarSign, Mv_SeminarDetail, M_WaterRecordWater } from './../model/water-record-model';
import { DataConfig } from './../shared/data.config';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';


@Injectable()
export class DataServiceService {
  result: any[] = [];
  Total: number;
  constructor(private http: HttpClient) { }

  private headers = new HttpHeaders({
    'Content-Type': DataConfig.contentJSON
  });
  // 檔案上傳使用
  private  headerfile = new HttpHeaders({
    'enctype': 'multipart/form-data'
  });




  getNews(search: string) {
    let options = {
      headers: this.headers,
    };

    let result = [];

    return this.http.get(DataConfig.apiBaseUrl + 'News?search=' + search, options).pipe(
      map(x => JSON.parse(x.toString()))
    );
  }

  getNewsByDate(year: number, searchString: string) {
    let options = {
      headers: this.headers,
    };


    let result = [];

    return this.http.get(DataConfig.apiBaseUrl + 'News?year=' + year.toString() + '&search=' + searchString, options).pipe(
      map(x => JSON.parse(x.toString()))
    );
  }

  getLaws(searchString: string) {
    let options = {
      headers: this.headers,
    };
    let result = [];

    return this.http.get(DataConfig.apiBaseUrl + 'Laws?search=' + searchString, options).pipe(
      map(x => JSON.parse(x.toString()))
    );
  }

  getLawsByDate(year: number, month: number, searchString: string) {
    let options = {
      headers: this.headers,
    };

    let result = [];

    return this.http.get(DataConfig.apiBaseUrl + 'Laws?year=' + year.toString() + '&month=' + month.toString() + '&search=' + searchString, options).pipe(
      map(x => JSON.parse(x.toString()))
    );
  }

  getYear(): Array<Select> {
    var YearList = new Array<Select>();
    var NowYear = new Date().getFullYear();
    YearList.push({ Name: "全部", Value: 0 })
    for (var i = 0; i < NowYear - 2001; i++) {
      var data = new Select();
      data.Name = "民國" + (NowYear - 1911 - i);
      data.Value = NowYear - i;
      YearList.push(data);
    }
    return YearList;
  }

  getFileDownload(Broadcast_sn: number) {
    let options = {
      headers: this.headers
    };

    return this.http.get(DataConfig.apiBaseUrl + 'FileDownload/' + Broadcast_sn, options).pipe(
      map(x => JSON.parse(x.toString())));
  }

  getGovList() {
    let options = {
      headers: this.headers
    };
    return this.http.get(DataConfig.apiBaseUrl + 'Gov', options).pipe(
      map(x => JSON.parse(x.toString())));
  }
  GetOldSelect(data: Mv_WaterRecordStatistics) {
    let options = {
      headers: this.headers
    };
    return this.http.post(DataConfig.apiBaseUrl + 'StaticFile', data, options).pipe(
      map(x => JSON.parse(x.toString())));
  }
  getAnnounce() {
    let options = {
      headers: this.headers
    };

    return this.http.get(DataConfig.apiBaseUrl + 'Announce', options).pipe(
      map(x => JSON.parse(x.toString())));
  }
  getOnline() {
    let options = {
      headers: this.headers
    };
    return this.http.post(DataConfig.apiBaseUrl + 'Announce', options).pipe(
      map(x => JSON.parse(x.toString())));
  }

  getAnnounceByDate(Gov_code_sn: number, searchText: string) {

    let body = {
      Gov_code_sn: Gov_code_sn,
      search:searchText
    }
    return this.http.put(DataConfig.apiBaseUrl + 'Announce', body,{ headers: this.headers }).pipe(
      map(x => JSON.parse(x.toString()))
    );

  }

  getWRDeviceList() {
    return this.http.get(DataConfig.apiBaseUrl + 'WRDevice', { headers: this.headers }).pipe(
      map(x => JSON.parse(x.toString())));
  }

  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }

  getCity() {
    let options = {
      headers: this.headers
    };

    return this.http.get(DataConfig.apiBaseUrl + 'Town', options).pipe(
      map(x => JSON.parse(x.toString()))
    );
  }

  getTownList(City_sn: number) {
    return this.http.get(DataConfig.apiBaseUrl + 'Town/' + City_sn, { headers: this.headers }).pipe(
      map(x => JSON.parse(x.toString()))
    );
  }
  getMonth(Year: number): Array<number> {
    var now = new Date();
    var monthList = new Array<number>();
    var month = 1;
    var end = 12;

    if (Year == 2011)
      month = 10;
    else if (Year == now.getFullYear()) {
      if (now.getDate() >= 25)
        end = now.getMonth() + 1;
      else
        end = now.getMonth();
    }

    for (var i = month; i <= end; i++) {
      monthList.push(i);
    }
    return monthList;
  }



  getSectionList(Town_sn: number) {
    return this.http.get(DataConfig.apiBaseUrl + 'Section/' + Town_sn, { headers: this.headers }).pipe(
      map(x => JSON.parse(x.toString()))
    );
  }

  getSubsectionList(Section_sn: number) {
    return this.http.get(DataConfig.apiBaseUrl + 'SubSection/' + Section_sn, { headers: this.headers }).pipe(
      map(x => JSON.parse(x.toString()))
    );
  }



  getWaterRecordData() {
    let options = {
      headers: this.headers
    };
    return this.http.get(DataConfig.apiBaseUrl + 'WaterList', options).pipe(
      map(x => JSON.parse(x.toString())));
  }

  getStatistics(formData: any) {
    let options = {
      headers: this.headers
    };

    return this.http.post(DataConfig.apiBaseUrl + 'OrgStatistics', formData, options).pipe(
      map(x => JSON.parse(x.toString()))
    );
  }

  exportExcel(data: Mv_WaterRecordStatistics) {
    return this.http.post(DataConfig.apiBaseUrl + 'PrintStatistics', data, { headers: this.headers }).pipe(
      map(x => JSON.parse(x.toString())));
  }
  getOldHTMLFile(data: Mv_WaterRecordStatistics) {
    let options = {
      headers: this.headers
    };
    return this.http.put(DataConfig.apiBaseUrl + 'StaticFile', data, options).pipe(
      map(x => JSON.parse(x.toString())));
  }

  SearchNewStream(data: Mv_WaterRecordStatistics) {
    let options = {
      headers: this.headers
    };
    return this.http.put(DataConfig.apiBaseUrl + 'OrgStatistics', data, options).pipe(
      map(x => JSON.parse(x.toString()))
    );
  }
  GetHeader() {
    var headers = new HttpHeaders({
      'Content-Type': DataConfig.contentJSON,
      'PersonName': this.AddCookieHeader()
    });
    return headers;

  }
  AddCookieHeader() {
    var SearchWord = "PersonName=";
    var Result = "";
    var username = document.cookie;

    var Check = username.indexOf(SearchWord);
    if (Check >= 0) {
      var site = username.indexOf(";", Check + SearchWord.length);
      if (site < 0) {
        Result = username.substring(Check + SearchWord.length);
      } else {
        Result = username.substr(Check + SearchWord.length, site - Check);
      }

      return Result;
    }
  }

  GetCitySelect() {
    return this.http.get(DataConfig.apiBaseUrl + 'City', { headers: this.headers }).pipe(
      map(x => JSON.parse(x.toString()))
    );
  }
  ///simulation
  Simulation_GetSelect(Status = 0 ) {
    return this.http.get(DataConfig.apiBaseUrl + 'Simulation?top=10&status='+Status , { headers: this.headers }).pipe(
      map(x => JSON.parse(x.toString()))
    );
  }
  Simulation_SearchPersonAndSelect(WaterRecordGroup_sn: number) {
    return this.http.get(DataConfig.apiBaseUrl + 'Simulation/' + WaterRecordGroup_sn, { headers: this.headers }).pipe(
      map(x => JSON.parse(x.toString()))
    );
  }
  Simulation_Login(WaterRecordPersonGroup: Mv_WaterRecordPersonGroup) {
    return this.http.post(DataConfig.apiBaseUrl + 'Simulation', WaterRecordPersonGroup, { headers: this.headers }).pipe(
      map(x => JSON.parse(x.toString()))
    );

  }
  ///
  ///WaterList
  WaterList_GetListOption(data: any) {
    return this.http.post(DataConfig.apiBaseUrl + 'Code', data, { headers: this.headers }).pipe(
      map(x => JSON.parse(x.toString()))
    );
  }
  WaterList_getWaterRecordData() {
    return this.http.get(DataConfig.apiBaseUrl + 'WaterList', { headers: this.GetHeader() }).pipe(
      map(x => JSON.parse(x.toString())));
  }
  WaterList_SearchWaterRecordList(data: Mv_WaterRecordLicen) {
    return this.http.post(DataConfig.apiBaseUrl + 'WaterList', data, { headers: this.GetHeader() }).pipe(
      map(x => JSON.parse(x.toString())));
  }
  WaterList_GetWaterRecordDataList(ApplyMain_sn: number) {
    return this.http.get(DataConfig.apiBaseUrl + 'WaterList/' + ApplyMain_sn, { headers: this.GetHeader() }).pipe(
      map(x => JSON.parse(x.toString())));
  }
  WaterList_ProduceExcel(WaterRecordLicen_sn: number) {
    return this.http.get(DataConfig.apiBaseUrl + 'WaterListExcel/' + WaterRecordLicen_sn, { headers: this.headers })
  }
  WaterList_ModifyWaterRecordString(data: M_WaterRecordWater, WaterRecordGroup_sn: number, flag: boolean) {
    return this.http.get(DataConfig.apiBaseUrl + 'WaterList/?no=' + data.RelatedNo + "&WaterRecordGroup_sn=" + WaterRecordGroup_sn + "&flag=" + flag, { headers: this.GetHeader() }).pipe(
      map(x => JSON.parse(x.toString())));
  }
  RecordData_SaveWaterRecordData(data: Mv_WaterRecordData, IsWaterMeter: boolean = null) {
    return this.http.put(DataConfig.apiBaseUrl + 'WaterList?=' + IsWaterMeter, data, { headers: this.GetHeader() }).pipe(
      map(x => JSON.parse(x.toString())));
  }
  RecordData_GetWaterRecordDataLogList(RelatedNo: string) {
    return this.http.get(DataConfig.apiBaseUrl + 'WaterListExtend/' + RelatedNo, { headers: this.GetHeader() }).pipe(
      map(x => JSON.parse(x.toString())));
  }
  RecordData_GetWaterRecordDataLog(ApplyMain_sn: number, RecordYear: number, RecordMonth: number) {
    const strWhere = '?ApplyMain_sn=' + ApplyMain_sn + '&RecordYear=' + RecordYear + '&RecordMonth=' + RecordMonth;
    return this.http.get(DataConfig.apiBaseUrl + 'WaterListExtend/' + strWhere, { headers: this.GetHeader() }).pipe(
      map(x => JSON.parse(x.toString())));
  }
  RecordData_GetWaterRecordMeter(RelatedNo: string ){
    return this.http.get(DataConfig.apiBaseUrl + 'WaterRecordMeter/?no=' + RelatedNo, { headers: this.GetHeader() }).pipe(
      map(x => JSON.parse(x.toString())));
  }
  RecordData_SaveWaterRecordMeter(data: M_WaterRecordWater, WaterRecordGroup_sn: number) {
    let body = {
      WaterRecordMeter_sn: data.WaterRecordMeter_sn,
      ApplyMain_sn: data.ApplyMain_sn,
      RelatedNo: data.RelatedNo,
      IsWaterMeter: data.IsWaterMeter,
      RecordString: data.RecordString,
      DeviceKind_code_name: data.DeviceKind_code_name,
      IsValid: data.IsValid,
      WaterRecordGroup_sn: WaterRecordGroup_sn
    };
    return this.http.put(DataConfig.apiBaseUrl + 'WaterRecordMeter/', body, { headers: this.GetHeader() }).pipe(
      map(x => JSON.parse(x.toString())));
  }

  ///
  ////Pass
  Pass_GetPersonData() {
    return this.http.get(DataConfig.apiBaseUrl + 'Pass', { headers: this.GetHeader() }).pipe(
      map(x => JSON.parse(x.toString())));

  }
  Pass_InsertWaterRecordPerson(data: M_WaterRecordPerson) {
    return this.http.put(DataConfig.apiBaseUrl + 'Pass', data, { headers: this.headers }).pipe(
      map(x => JSON.parse(x.toString())));
  }
  ///
  ///new-waterright
  NewWaterRight_GetSelect() {
    return this.http.get(DataConfig.apiBaseUrl + 'NewWaterRight', { headers: this.GetHeader() }).pipe(
      map(x => JSON.parse(x.toString())));

  }
  NewWaterRight_SearchAndAddWaterRight(data: Mv_WaterRecordLicen) {
    return this.http.post(DataConfig.apiBaseUrl + 'NewWaterRight', data, { headers: this.GetHeader() }).pipe(
      map(x => JSON.parse(x.toString())));

  }
  ///Unit-Manage
  UnitManage_GetUnitList() {
    return this.http.get(DataConfig.apiBaseUrl + 'UnitManage', { headers: this.GetHeader() }).pipe(
      map(x => JSON.parse(x.toString())));

  }
  UnitManage_SaveWaterRecordGroup(data: Mv_WaterRecordPersonGroup) {
    return this.http.put(DataConfig.apiBaseUrl + 'UnitManage', data, { headers: this.GetHeader() }).pipe(
      map(x => JSON.parse(x.toString())));
  }
  UnitManage_SearchWaterRecordPersonByGroup(WaterRecordGroup_sn) {
    return this.http.get(DataConfig.apiBaseUrl + 'UnitManagePerson/' + WaterRecordGroup_sn, { headers: this.GetHeader() })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }
  UnitManage_SaveWaterRecordPerson(data: Mv_WaterRecordPersonGroup) {
    return this.http.put(DataConfig.apiBaseUrl + 'UnitManagePerson', data, { headers: this.GetHeader() })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }
  UnitManage_GetWaterRightList(WaterRecordGroup_sn) {
    return this.http.get(DataConfig.apiBaseUrl + 'UnitManageWaterRight/' + WaterRecordGroup_sn, { headers: this.GetHeader() })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }
  UnitManage_GetWaterReocrAndLog(data: Mv_WaterRecordLicen) {
    return this.http.post(DataConfig.apiBaseUrl + 'UnitManageWaterRight', data, { headers: this.GetHeader() })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }
  UnitManage_DeleteWaterRecordGroup(WaterRecordGroup_sn) {
    return this.http.delete(DataConfig.apiBaseUrl + 'UnitManage/' + WaterRecordGroup_sn, { headers: this.GetHeader() })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }
  UnitManage_DeleteWaterRecordPerson(WaterRecordPersonGroup_sn) {
    return this.http.delete(DataConfig.apiBaseUrl + 'UnitManagePerson/' + WaterRecordPersonGroup_sn, { headers: this.GetHeader() })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }
  //WaterSearch
  WaterSearch_SearchWaterRecord(data: Mv_WaterRecordData) {
    return this.http.post(DataConfig.apiBaseUrl + 'WaterSearch', data, { headers: this.GetHeader() })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }
  WaterSearch_ProduceExcel(data: Mv_WaterRecordData) {
    return this.http.put(DataConfig.apiBaseUrl + 'WaterSearch', data, { headers: this.GetHeader() })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }
  WaterSearch_Init() {
    return this.http.get(DataConfig.apiBaseUrl + 'WaterSearch', { headers: this.GetHeader() })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }
  ///CaseSearch
  CaseSearch_SearchCaseProcess(data: Mv_WaterRecordLicen) {
    return this.http.post(DataConfig.apiBaseUrl + 'CaseSearch', data, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  CaseSearch_GetOnInit() {
    return this.http.get(DataConfig.apiBaseUrl + 'CaseSearch', { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  CaseSearch_PutSearchData(obj: any) {
    return this.http.put(DataConfig.apiBaseUrl + 'CaseSearch', obj, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }
  //SeminarList
  SeminarList_GetSeminarList() {
    return this.http.get(DataConfig.apiBaseUrl + 'Seminar', { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }
  //SeminarDetail
  SeminarDetail_GetSeminarDetailList(Seminar_sn: number) {
    return this.http.get(DataConfig.apiBaseUrl + 'Seminar/' + Seminar_sn, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  //線上申請用============================================
  DecryptRouter(obj: any) { //申請流程-路由解密
    return this.http.post(DataConfig.apiBaseUrl + 'DecryptRouter', obj, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }


  GetEncryptString(obj: any) { //路由加密
    return this.http.post(DataConfig.apiBaseUrl + 'EncryptRouter', obj, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  GetGWCtrl(obj: any) {//判斷是否為地下水管制區
    return this.http.post(DataConfig.apiBaseUrl + 'OptGWCtrl', obj, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  ApplyCase_Porcess(obj: any) { //線上申請流程換頁
    return this.http.post(DataConfig.apiBaseUrl + 'ApplyCaseProcess', obj, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  ApplyCase_SendVerificationEmail(ApplyMain_sn: number,OnlineType:number) { //線上申請-發送驗證信
    return this.http.get(DataConfig.apiBaseUrl + 'VerificationEmail?id=' + ApplyMain_sn + "&OnlineType=" + OnlineType , { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  ApplyCase_GetVerificationEmail(obj: any) { //線上申請-驗證信箱
    return this.http.post(DataConfig.apiBaseUrl + 'VerificationEmail', obj, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  ApplyCase_GetOnInit() {
    return this.http.get(DataConfig.apiBaseUrl + 'ApplyCase', { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  ApplyCase_ChangeApplyType(ApplyKind_code_sn: number) {
    return this.http.put(DataConfig.apiBaseUrl + 'ApplyCase/' + ApplyKind_code_sn, '', { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  ApplyCase_Search(obj: Mv_ApplyCase_Search) {
    return this.http.post(DataConfig.apiBaseUrl + 'ApplyCase', obj, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application01_GetOnInit() {
    return this.http.get(DataConfig.apiBaseUrl + 'Application01', { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application01_GetData(obj: any) {
    return this.http.put(DataConfig.apiBaseUrl + 'Application01/', obj, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application01_Save(obj: any) {
    return this.http.post(DataConfig.apiBaseUrl + 'Application01', obj, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application02_GetOnInit(Gov_code_sn: number) {
    return this.http.get(DataConfig.apiBaseUrl + 'Application02/' + Gov_code_sn, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application02_GetData(obj: any) {
    return this.http.put(DataConfig.apiBaseUrl + 'Application02/', obj, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application02_Save(obj: any) {
    return this.http.post(DataConfig.apiBaseUrl + 'Application02', obj, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application03_GetData(obj: any) {
    return this.http.get(DataConfig.apiBaseUrl + 'Application03/' + obj, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application03_Save(obj: any) {
    return this.http.post(DataConfig.apiBaseUrl + 'Application03', obj, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application04_GetOnInit() {
    return this.http.get(DataConfig.apiBaseUrl + 'Application04', { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application04_GetData(obj: any) {
    return this.http.get(DataConfig.apiBaseUrl + 'Application04/' + obj, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application04_Save(obj: any) {
    return this.http.post(DataConfig.apiBaseUrl + 'Application04', obj, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application04_GetGWCompany(obj: any) {
    return this.http.put(DataConfig.apiBaseUrl + 'Application04', obj, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application05_GetOnInit() {
    return this.http.get(DataConfig.apiBaseUrl + 'Application05', { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application05_GetData(obj: any) {
    return this.http.get(DataConfig.apiBaseUrl + 'Application05/' + obj, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application05_Save(obj: any) {
    return this.http.post(DataConfig.apiBaseUrl + 'Application05', obj, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application05_GetFiles(ApplyMain_sn: number) {
    return this.http.put(DataConfig.apiBaseUrl + 'Application05/' + ApplyMain_sn, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application05_FileUpload(obj: any) {
    var headers = new HttpHeaders();         // Post標頭檔
    headers.append("enctype", "multipart/form-data");
    return this.http.post(DataConfig.apiBaseUrl + 'FileUpload', obj, { headers: headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application06_GetData(ApplyMain_sn: number) {
    return this.http.get(DataConfig.apiBaseUrl + 'Application06/' + ApplyMain_sn, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application06_Save(obj: any) {
    return this.http.post(DataConfig.apiBaseUrl + 'Application06', obj, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application07_GetSave_ApplyProcessByOnline(ApplyMain_sn: number) {
    return this.http.get(DataConfig.apiBaseUrl + 'Application07/' + ApplyMain_sn, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application08_GetApplyAppendix(ApplyMain_sn: number) {
    return this.http.get(DataConfig.apiBaseUrl + 'Application08/' + ApplyMain_sn, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application08_FileUpload(obj: any) {
    var headers = new HttpHeaders();         // Post標頭檔
    headers.append("enctype", "multipart/form-data");
    return this.http.post(DataConfig.apiBaseUrl + 'Application08', obj, { headers: headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application08_GetFiles(ApplyMain_sn: number) {
    return this.http.put(DataConfig.apiBaseUrl + 'Application08/' + ApplyMain_sn, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application08_DelFiles(obj: any) {
    return this.http.put(DataConfig.apiBaseUrl + 'Application08', obj, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application09_GetOnInit(ApplyMain_sn: number) {
    return this.http.get(DataConfig.apiBaseUrl + 'Application09/' + ApplyMain_sn, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application09_FileUpload(obj: any) {
    var headers = new HttpHeaders();         // Post標頭檔
    headers.append("enctype", "multipart/form-data");
    return this.http.post(DataConfig.apiBaseUrl + 'Application09', obj, { headers: headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application09_GetFiles(ApplyMain_sn: number) {
    return this.http.put(DataConfig.apiBaseUrl + 'Application09/' + ApplyMain_sn, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application09_DelFiles(FileUpload_sn: number) {
    return this.http.delete(DataConfig.apiBaseUrl + 'Application09/' + FileUpload_sn, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application09_ConfirmPay(ApplyMain_sn: number) {
    return this.http.post(DataConfig.apiBaseUrl + 'Application09/' + ApplyMain_sn, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  //先把ApplyMain_sn存到Session
  GetUniqueNumber(ApplyMain_sn: number) {
    return this.http.get(DataConfig.apiBaseUrl + 'EPay/' + ApplyMain_sn, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  EPayCheck_OnInit(DecryptString: string) {
    var obj = {
      DecryptString: DecryptString
    };
    return this.http.post(DataConfig.apiBaseUrl + 'EPayReturnCheck/', obj, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }



  Application02_GetCode_ByRefer(obj: Mv_PostCode) {
    return this.http.post(DataConfig.apiBaseUrl + 'Code', obj, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application02_GetEasyWaterSystem(Town_sn: number) {
    return this.http.get(DataConfig.apiBaseUrl + 'EasyWaterSystem/' + Town_sn, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  Application07_goWaterRegion(obj: any) {
    return this.http.post(DataConfig.apiBaseUrl + 'WaterRegion', obj, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }

  SeminarDetail_AddSeminarSigh(data: Mv_SeminarSign) {
    return this.http.put(DataConfig.apiBaseUrl + 'Seminar', data, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }
  ///SeminarSign
  SeminarSign_SearchSeminarSignList(data: Mv_SeminarDetail) {
    return this.http.post(DataConfig.apiBaseUrl + 'Seminar', data, { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));
  }
  // /-----年報統計圖表 Start-----///
  YearReportChartSearch() {
    return this.http.post(DataConfig.apiBaseUrl + 'YearReportChart', '', { headers: this.headers })
      .pipe(
        map(x => JSON.parse(x.toString())));

  }
  // 座標檢查
  CheckCoordinate(obj:any) {
    return this.http.post(DataConfig.apiBaseUrl + 'CheckCoordinate',obj, { headers: this.headers })
    .pipe(
      map(x => JSON.parse(x.toString())));
  }
  // 申請書列印
  PrintApply(ApplyCase_sn:number) {
    return this.http.get(DataConfig.apiBaseUrl + 'PrintApply/'+ApplyCase_sn, { headers: this.headers })
    .pipe(
      map(x => JSON.parse(x.toString())));
  }
    //取回聯合運用水量
    LoadRelateRecord(obj: any) {
      return this.http.post(DataConfig.apiBaseUrl + 'WaterRecordRelate', obj, { headers: this.headers }).pipe(
        map(x => JSON.parse(x.toString()))
      );
    }
    //檔案上傳功能
  ExcelfileUpload(FileArray) {
    return this.http.post(DataConfig.apiBaseUrl + 'Application06', FileArray, { headers: this.headerfile }).pipe(
      map(x => JSON.parse(x.toString()))
    );
  }
  PrintRecord(ApplyMain_sn:number) {
    return this.http.get(DataConfig.apiBaseUrl + 'Application06?RelatedNo=0&ApplyMain_sn='+ ApplyMain_sn , { headers: this.headers }).pipe(
      map(x => JSON.parse(x.toString()))
    );
  }
  AddYear(obj:any) {
    return this.http.post(DataConfig.apiBaseUrl + 'Date',obj, { headers: this.headers })
    .pipe(
      map(x => JSON.parse(x.toString())));
  }
  GetOptStream(gov:number) {
    return this.http.get(DataConfig.apiBaseUrl + 'ApplyCase?id='+gov , { headers: this.headers })
    .pipe(
      map(x => JSON.parse(x.toString())));
  }


}
